import { cloneDeep } from "lodash";

import { ObjectKeys } from "@/utils/object.utils";

import { searchSliderMinMaxValues } from "../constants";
import { SearchInputsSchema, SearchPageQueryInputsParams } from "../models";

type MatchingArrayKeys = Pick<
  SearchPageQueryInputsParams,
  "minAge" | "maxAge" | "minHeight" | "maxHeight" | "minWeight" | "maxWeight"
>;

export const convertUrlParamsToFormValues = (
  searchParams: URLSearchParams,
): SearchInputsSchema | null => {
  if (!Array.from(searchParams.entries()).length) return null;

  const resultFormValues = {} as SearchInputsSchema;
  const arraysOfSliderValues: Record<"age" | "height" | "weight", number[]> = {
    age: cloneDeep(searchSliderMinMaxValues.ageMinMax),
    height: cloneDeep(searchSliderMinMaxValues.heightMinMax),
    weight: cloneDeep(searchSliderMinMaxValues.weightMinMax),
  } as const;

  for (const [key, value] of searchParams.entries()) {
    const targetKey = key as keyof MatchingArrayKeys;

    switch (targetKey) {
      case "minAge":
        arraysOfSliderValues.age[0] = Number(value);
        break;
      case "maxAge":
        arraysOfSliderValues.age[1] = Number(value);
        break;
      case "minHeight":
        arraysOfSliderValues.height[0] = Number(value);
        break;
      case "maxHeight":
        arraysOfSliderValues.height[1] = Number(value);
        break;
      case "minWeight":
        arraysOfSliderValues.weight[0] = Number(value);
        break;
      case "maxWeight":
        arraysOfSliderValues.weight[1] = Number(value);
        break;
    }

    const boolVals = {
      false: false,
      true: true,
    };

    if (value === "false" || value === "true") {
      resultFormValues[key as keyof SearchInputsSchema] = boolVals[
        value
      ] as TODO;
      continue;
    }

    resultFormValues[key as keyof SearchInputsSchema] = value as TODO;
  }

  const keysOfArrParams = ObjectKeys(arraysOfSliderValues);

  keysOfArrParams.forEach((key) => {
    resultFormValues[key] = arraysOfSliderValues[key];
  });

  return resultFormValues;
};
